export const getThemeFriendlyProductCode = (configData, fallBack = "dmp") => {
  return configData?.productInfo?.productCode || fallBack;
};
